import { Trans, useLingui } from "@lingui/react";
import { TradeOrgPages } from "src/types/tradeorgPages.ts";
import OrgLinks from "./components/OrgLinks.tsx";
import Title from "./components/Title.tsx";
import { Layout } from "./Layout.tsx";

const Ncb = () => {
  const { i18n } = useLingui();
  const pageName = TradeOrgPages.NCB;

  const pageTitle = i18n._({
    id: "tradeOrgLayout.page.title",
    message: "Advantages with {tradeOrgName}",
    comment: "Page title with trade organization name",
    values: { tradeOrgName: pageName.toUpperCase() },
  });

  const subTitle = i18n._({
    id: "tradeOrgLayout.ncb.subtitle.text",
    message:
      "The Norwegian Caravan Industry Association (NCB) organizes the professional and serious players in the Norwegian caravan industry. As a consumer, you should be safer when you shop with an NCB member. Look for our logo when you buy a motorhome or caravan.",
    comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
  });

  return (
    <Layout
      left={
        <>
          <Title title={pageTitle} subTitle={subTitle} />

          <div className="mt-40">
            <div className="mt-40 pb-40 border-b md:border-none">
              <p className="mt-16 mb-0">
                <Trans
                  id="tradeOrgLayout.ncb.section.one.text"
                  message="We depend on the trust of consumers. Following Norwegian law is a prerequisite for membership in the Norwegian Caravan Industry Association, in addition all members sign our ethical regulations, which gives you as a customer even more security."
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </p>

              <p className="mt-16 mb-0">
                <Trans
                  id="tradeOrgLayout.ncb.section.two.text"
                  message="Our goal for good customer care is that our customers should have security for their purchases and that the products should be of the best quality. We work continuously to ensure that you as a customer have security in all purchase and workshop situations. NCB conducts training for member companies' employees, so that we have well-qualified employees for the customer's benefit."
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </p>

              <p className="mt-16 mb-0">
                <Trans
                  id="tradeOrgLayout.ncb.section.three.text"
                  message="We bring the industry together and collaborate across caravan and motorhome brands. We work to ensure that customers experience that they get the best service, the best advice and do the best shopping at our member companies."
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </p>

              <h4 className="t4 mt-16 mb-0">
                <Trans
                  id="tradeOrgLayout.ncb.section.four.text"
                  message="Look for our membership badge if you are going to make a safe trade!"
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </h4>
            </div>
          </div>
        </>
      }
      right={<OrgLinks pageName={pageName} />}
    />
  );
};

export default Ncb;
